<template>
    <div>
        <v-container fluid v-if="visitDetails">
            <v-row>
                <v-col cols="6">
                    <v-text-field prepend-icon="fa-calendar-alt" readonly label="Data wizyty" :value="formattedDate"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field prepend-icon="fa-clock" readonly label="Godzina" :value="formattedTime"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-expansion-panels accordion multiple focusable hover>
                        <v-expansion-panel v-if="visitDetails.recommendations">
                            <v-expansion-panel-header>Zalecenia</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="html-content" v-html="visitDetails.recommendations"></div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="visitDetails.recognition">
                            <v-expansion-panel-header>Rozpoznanie</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="html-content" v-html="visitDetails.recognition"></div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="visitDetails.process">
                            <v-expansion-panel-header>Przebieg</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="html-content" v-html="visitDetails.process"></div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                    <v-btn color="primary" @click="$emit('visitHistory')">Historia wizyt</v-btn>
                </v-col>
            </v-row>
            <v-overlay :value="loading">
                <v-progress-circular indeterminate size="60" color="success"></v-progress-circular>
            </v-overlay>
        </v-container>
        <v-container flud v-if="!visitDetails">
            <v-row>
                <v-col cols="12">
                    Brak poprzednich wizyt...
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import * as dayjs from "dayjs";
    import swal from "sweetalert";
    import {visitService} from "../../services";
    export default {
        name: "TherapistPreviousVisit",
        props: ['id'],
        data() {
            return {
                loading: false,
                visitDetails: null
            }
        },
        computed: {
            formattedDate() {
                if(this.visitDetails.startTime)
                {
                    return dayjs(this.visitDetails.startTime).format('DD-MM-YYYY')
                }
                else
                {
                    return ''
                }
            },
            formattedTime() {
                if(this.visitDetails && this.visitDetails.endTime)
                {
                    return dayjs(this.visitDetails.startTime).format('HH:mm')+' - '+dayjs(this.visitDetails.endTime).format('HH:mm')
                }
                else
                {
                    return ''
                }
            }
        },
        methods: {
            loadData(){
                this.loading = true
                visitService.GetTherapistPreviousVisit(this.id).then(result => {
                    if(result != null && result.data != null && result.data.result != null)
                    {
                        this.visitDetails = result.data.result
                        this.title = 'Wizyta: '+this.visitDetails.clientName + ' '+this.visitDetails.clientSurname
                    }
                    this.loading = false
                }).catch(() => {
                    this.showError(true,"Błąd pobierania informacji o wizycie.");
                    this.loading = false
                })
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            }
        },
        watch: {
            id: {
                immediate: true,
                handler(newval) {
                    if (newval != null) {
                            this.loadData();
                        }
                    }
                }
        }
    }
</script>

<style>
.html-content {
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    min-height: 100px;
}

.html-content p {
    margin-bottom: 8px;
}

.html-content ul, .html-content ol {
    margin-left: 20px;
    margin-bottom: 8px;
}

.html-content strong {
    font-weight: bold;
}

.html-content em {
    font-style: italic;
}

.html-content h1, .html-content h2, .html-content h3 {
    margin-top: 16px;
    margin-bottom: 8px;
}

.html-content h1 {
    font-size: 1.5em;
}

.html-content h2 {
    font-size: 1.3em;
}

.html-content h3 {
    font-size: 1.1em;
}
</style>